import { render, staticRenderFns } from "./ProfessionalsPrivacyPolicy.vue?vue&type=template&id=ff6b92ca&scoped=true&"
import script from "./ProfessionalsPrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./ProfessionalsPrivacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionalsPrivacyPolicy.vue?vue&type=style&index=0&id=ff6b92ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6b92ca",
  null
  
)

component.options.__file = "ProfessionalsPrivacyPolicy.vue"
export default component.exports